import { SET_ROUTE_SPEED_COLOR } from "../actions/routeSpeedColorActions";

import { states as queriesStates } from "./queriesStates";

const initialState = {
  dataState: queriesStates.NOT_REQUESTED,
  routeSpeedColorKey: new Date(),
  routeSpeedColor: {
    isOn: false,
    items: [
      {
        min: 0,
        max: 200,
        color: "#3388ff",
      },
    ],
  },
};

const routeSpeedColorReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ROUTE_SPEED_COLOR: {
      return Object.assign({}, state, {
        dataState: queriesStates.READY,
        routeSpeedColorKey: new Date(),
        routeSpeedColor: action.data,
      });
    }

    default:
      return state;
  }
};

export default routeSpeedColorReducer;
